import React, { useCallback, useState, useRef, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import slugify from "slugify";

import {
  Button,
  Form,
  Input,
  Modal,
  Select,
  Space,
  Divider,
  Card,
  Row,
  Col,
} from "antd";

import { AiFillCheckCircle, AiFillCloseSquare } from "react-icons/ai";
import { useSelector, useDispatch } from "react-redux";
import { systemActions } from "../../store";
import ENV from "../../consts/config";
import Swal from "sweetalert2";
import FileChonky from "../../components/chonky/index";
import ReactDOM from "react-dom";

import { Editor } from "@tinymce/tinymce-react";
import pageApi from "../../api/pageApi";
import UpFileSingleProp from "../../components/UpFileSingleProp";

const PageAdd = (props) => {
  const dispatch = useDispatch();
  let navigate = useNavigate();
  const goToPreviousPath = () => {
    navigate(-1);
  };

  const back = () => {
    confirm({
      title: "Mọi chỉnh sửa sẽ bị mất ! Tiếp tục quay lại?",
      onOk() {
        goToPreviousPath();
      },
      onCancel() {},
    });
  };

  const { TextArea } = Input;

  const contentRef = useRef(null);
  const descriptionRef = useRef(null);

  const confirm = Modal.confirm;
  // const { Option } = Select;
  const [form] = Form.useForm();

  // const [description, setDescription] = useState("");
  // const [content, setContent] = useState("");

  const [valueForm, setValueForm] = useState({
    title: null,
    slug: null,
    description: null,
    content: null,
    seoTitle: null,
    seoDescription: null,
    seoKeywords: null,
  });


  const { user: authUser } = useSelector((x) => x.auth);


  const [image, setImage] = useState(null);

  const onUploadImage = (url) => {
    setImage(url);
  };


  const setLoading = (status) => {
    dispatch(systemActions.setLoadingSystem(status));
  };

  useEffect(() => {
    form.setFieldsValue(valueForm);
  }, [valueForm]);

  const titleChange = useCallback(
    (values) => {
      const slug = slugify(values).toLowerCase();
      form.setFieldsValue({
        slug: slug,
      });
    },
    [form]
  );

  const onFinishFailed = (errorInfo) => {
    console.log("Failed:", errorInfo);
  };

  const onFinish = (values) => {
    createBlog(values);
  };

  const createBlog = (data) => {
    setLoading(true);

    let description = "";
    if (descriptionRef.current) {
      description = descriptionRef.current.getContent() || "";
    }

    let content,
      contentNonHtml = "";

    if (contentRef.current) {
      let _content = contentRef.current.getContent() || "";

      if (_content !== "") {
        _content = _content.replaceAll(
          `${ENV.CDN_URL}`,
          `${ENV.IMAGE_VARIABLE}`
        );
      }

      // let _contentNonHtml =
      //   contentRef.current.getContent({ format: "text" }) || "";

      // if (_contentNonHtml !== "") {
      //   _contentNonHtml = _contentNonHtml.replaceAll(
      //     `${ENV.CDN_URL}`,
      //     `${ENV.IMAGE_VARIABLE}`
      //   );
      // }
      content = _content;
      // contentNonHtml = _contentNonHtml;
    }

    const payload = {
      title: data.title,
      slug: data.slug,
      description: description,
      seoImage : image,
      seoTitle: data.seoTitle,
      seoDescription: data.seoDescription,
      seoKeywords: data.seoKeywords,
      content: content,
      // contentNonHtml: contentNonHtml,
    };

    pageApi.createPage(payload).then(
      (res) => {
        if (!res.code) {
          Swal.fire({
            title: "Thành Công!",
            text: "Tạo thành công!",
            icon: "success",
            confirmButtonText: "OK",
          });
          setLoading(false);
          goToPreviousPath();
        } else {
          Swal.fire({
            title: "Thất bại!",
            text: res.message,
            icon: "error",
            confirmButtonText: "OK",
          });
        }
      },
      (err) => {
        // console.log("err", err);
        setLoading(false);
        Swal.fire({
          title: "Thất bại!",
          text: err.response?.data?.message,
          icon: "error",
          confirmButtonText: "OK",
        });
      }
    );
  };
  const showBox = (callback, value, meta) => {
    const ModalFile = (props) => {
      const [show, setShow] = useState(true);
      const [image, setImage] = useState();
      useEffect(() => {}, []);
      const onSelected = (data) => {
        setImage(data);
      };
      const onAction = () => {
        document.querySelector(".tox .tox-dialog-wrap").style.display = "";
        ReactDOM.unmountComponentAtNode(props.modal);
      };
      return (
        <>
          <Modal
            title=""
            visible={show}
            width={1300}
            style={{ top: 20 }}

            onOk={() => {
              setShow(false);
              props.callback(`${ENV.CDN_URL}${image}`);
              onAction();
            }}
            okButtonProps={{
              disabled: !image,
            }}
            onCancel={() => {
              setShow(false);
              onAction();
            }}
            destroyOnClose={true}
          >
            {authUser ? (
              <div style={{ padding: "15px" }}>
                <style>
                  {`.ant-modal-wrap{
            z-index: 1300
          } .ant-image-preview-wrap{z-index: 1301}`}
                </style>
                <FileChonky onSelected={onSelected} /> 
                <br />
              </div>
            ) : null}
          </Modal>
        </>
      );
    };
    const modal = document.createElement("span");
    document.querySelector(".tox .tox-dialog-wrap").style.display = "none";
    ReactDOM.render(<ModalFile modal={modal} callback={callback} />, modal);
  };

  return (
    <>
      <Row gutter={[24, 24]}>
        <Col span={24} md={24} className="mb-24">
          <Card
            className="header-solid h-full"
            bordered={false}
            title={<h6 className="font-semibold m-0">Thêm trang động</h6>}
            extra={
              <>
                <Space>
                  <Button
                    type="primary"
                    icon={<AiFillCheckCircle />}
                    onClick={() => {
                      form.submit();
                    }}
                  >
                    &nbsp;Lưu
                  </Button>
                  <Button
                    type="danger"
                    icon={<AiFillCloseSquare />}
                    onClick={() => {
                      back();
                    }}
                  >
                    &nbsp;Hủy
                  </Button>
                </Space>
              </>
            }
            bodyStyle={{ paddingTop: "0" }}
          >
            <Divider />
            <Form
              form={form}
              initialValues={valueForm}
              onFinish={onFinish}
              onFinishFailed={onFinishFailed}
              labelCol={{
                span: 2,
              }}
              layout="horizontal"
              size="large"
            >
              <Form.Item
                label="Tên bài viết"
                name="title"
                tooltip="Tên hiển thị của bài viết"
                onChange={(e) => {
                  titleChange(e.target.value);
                }}
                rules={[
                  {
                    required: true,
                    message: "Vui lòng nhập!",
                  },
                ]}
              >
                <Input />
              </Form.Item>
              <Form.Item
                label="Slug"
                name="slug"
                rules={[
                  {
                    pattern: new RegExp(/^[a-z0-9]+(?:-[a-z0-9]+)*$/),
                    message: "Slug không đúng định dạng!",
                  },
                  {
                    required: true,
                    message: "Thiếu dữ liệu!",
                  },
                ]}
              >
                <Input />
              </Form.Item>

              <Form.Item
                label="Ảnh Thumbnail"
                tooltip="Ảnh hiển thị trên social"
              >
                <UpFileSingleProp onUploadImage={onUploadImage} image={image} />
              </Form.Item>

              <Form.Item label="Thẻ tiêu đề" name="seoTitle">
                <Input />
              </Form.Item>

              <Form.Item label="Mô tả meta" name="seoDescription">
                <TextArea rows={4} />
              </Form.Item>

              <Form.Item label="Từ khóa meta" name="seoKeywords">
                <Input />
              </Form.Item>

              <Form.Item
                label="Mô tả ngắn"
                tooltip="Mô tả rút gọn của bài viết"
              >
                <Editor
                  tinymceScriptSrc={
                    process.env.PUBLIC_URL + "/tinymce/tinymce.min.js"
                  }
                  onInit={(evt, editor) => (descriptionRef.current = editor)}
                  init={{
                    height: 300,
                    menubar: false,
                    language: "vi",
                    plugins: [
                      "advlist",
                      "autolink",
                      "lists",
                      "link",
                      "charmap",
                      "preview",
                      "anchor",
                      "searchreplace",
                      "visualblocks",
                      "code",
                      "fullscreen",
                      "insertdatetime",
                      "media",
                      "table",
                      "help",
                      "wordcount",
                    ],
                    toolbar:
                      "undo redo | blocks | " +
                      "bold italic forecolor | alignleft aligncenter " +
                      "alignright alignjustify | bullist numlist outdent indent | " +
                      "removeformat | help",
                    content_style:
                      "body { font-family:Helvetica,Arial,sans-serif; font-size:14px }",
                  }}
                />
              </Form.Item>
              <Form.Item label="Nội dung" tooltip="Nội dung của bài viết">
                <Editor
                  tinymceScriptSrc={
                    process.env.PUBLIC_URL + "/tinymce/tinymce.min.js"
                  }
                  onInit={(evt, editor) => (contentRef.current = editor)}
                  // initialValue=""
                  init={{
                    height: 600,
                    menubar: true,
                    image_title: true,
                    file_picker_callback: showBox,
                    file_picker_types: "image",
                    language: "vi",
                    plugins: [
                      "advlist",
                      "autolink",
                      "lists",
                      "link",
                      "image",
                      "charmap",
                      "preview",
                      "anchor",
                      "searchreplace",
                      "visualblocks",
                      "code",
                      "fullscreen",
                      "insertdatetime",
                      "media",
                      "table",
                      "help",
                      "wordcount",
                    ],
                    toolbar:
                      "undo redo  | link image | blocks | " +
                      "bold italic forecolor | alignleft aligncenter " +
                      "alignright alignjustify | bullist numlist outdent indent | " +
                      "removeformat | help",
                    content_style:
                      "body { font-family:Helvetica,Arial,sans-serif; font-size:14px }",
                  }}
                />
              </Form.Item>
            </Form>
          </Card>
        </Col>
      </Row>
    </>
  );
};

export default PageAdd;
